import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const COMMENTS_PER_PAGE = 20;

/**
 * @var string v1
 * @type {string}
 */
const v1 = '/rest/v1.0';

export const ADD_COMMENT_URL =
  `${BASE_URL}/rest/v1.0/profile/{username}/comments/add`;

export const ALL_COMMENTS_URL =
  `${BASE_URL}/rest/v1.0/profile/{username}/comments`;

export const DELETE_COMMENT_URL =
  `${BASE_URL}/rest/v1.0/profile/{username}/comments/delete`;

export const GET_PERFORMER_VIDEOS =
  `${BASE_URL}${v1}/marketplace/videos`;

export const GET_PLAY_URL =
  `${BASE_URL}/rest/v1.0/marketplace/videos/{id}/videoPlay`;

export const LIBRARY_VIDEOS_URL =
  `${BASE_URL}/rest/v1.0/marketplace/libraries/videos/{username}`;

export const SET_COMMENTS_URL =
  `${BASE_URL}/rest/v1.0/profile/{username}/comments/${COMMENTS_PER_PAGE}?offset={offset}`;
